import { Select, Spin } from "antd";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { ISelectOption } from "../../models/utils/selectOption";
import { defaultFilterOption } from "../../utils";
import { EntFarmOwnerFilter } from "../../models/filters/farmOwnersFilter";
import { useLazyGetFarmOwnersListQuery } from "../../redux/api/farmOwners/farmOwnersApi";
import { EntFarmOwner } from "../../models/farmOwners";
import { useGetDataOnScroll } from "../getDataOnScrollProps/useGetDataOnScrollProps";

interface IProps {
    value?: number | null;
    onChange?: (v: number) => void;
}

const SelectOwner = (props: IProps) => {
    const { t } = useTranslation();
    const [options, setOptions] = useState<ISelectOption[]>([]);

    const [getData] = useLazyGetFarmOwnersListQuery();
    const {
        fetching,
        data,
        setData,
        setFetching,
        setFilter,
        scrollHandler,
        setCurrentPage
    } = useGetDataOnScroll<EntFarmOwner, EntFarmOwnerFilter>({
        initialFilter: new EntFarmOwnerFilter(),
        query: getData
    });

    useEffect(() => {
        const options = Array.from(new Set(data)).map((a) => {
            return { label: `${ a.secondName } ${ a.name } ${ a.patronymic ?? '' }`, value: a.id ?? '' };
        });
        setOptions(options);
    }, [data]);

    const search = (value?: string) => {
        if (!value) return;
        const filter = new EntFarmOwnerFilter();
        filter.fullName = value;
        setFilter(filter);
        setData([]);
        setCurrentPage(0);
        setFetching(true);
    }
    const clear = () => {
        const filter = new EntFarmOwnerFilter();
        filter.fullName = null;
        setFilter(filter);
        setData([]);
        setCurrentPage(0);
        setFetching(true);
    }

    return (
        <Select
            placeholder={ t("msg.selectPlaceholder") }
            onClear={ clear }
            onSearch={ search }
            onPopupScroll={ scrollHandler }
            loading={ fetching }
            value={ props.value }
            onChange={ props.onChange }
            options={ options }
            filterOption={ defaultFilterOption }
            showSearch
            allowClear
            dropdownRender={ (menu) => (
                <Spin spinning={ fetching }>
                    { menu }
                </Spin>
            ) }
        />
    );
};

export default SelectOwner;
